module.exports = __webpack_public_path__ + "img/icon-flag-fr.4b371f8c.svg";